module.exports = __webpack_public_path__ + "static/img/img_logo.3135ab1e.png";